import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
interface SelectMenuProps {
  reload?: boolean;
}

export function useSelectMenu(params: SelectMenuProps = { reload: false }) {
  const { reload } = params;
  const navigate = useNavigate();

  const openDrawer = useCallback(
    (item: { path: string; title: string }) => {
      if (item.path) {
        navigate(item.path);
        document.title = `Datasales - ${item.title}`;
        if (reload) window.location.reload();
      }
    },
    [navigate, reload]
  );

  const selectMenuShort = (param: string) => {
    switch (param) {
      case 'whatsapp':
        openDrawer({ path: '/whatsapp', title: 'WhatsApp' });
        break;
      case 'forms':
        openDrawer({ path: '/forms', title: 'Forms' });
        break;
      case 'enrichment':
        openDrawer({ path: '/enrichment', title: 'enrichment' });
        break;
      case 'blacklist':
        openDrawer({ path: '/blacklist', title: 'blacklist' });
        break;
      case 'answers':
        openDrawer({ path: '/answers', title: 'answers' });
        break;
      case 'form-delivery':
        openDrawer({ path: '/form-delivery', title: 'form-delivery' });
        break;
      case 'results':
        openDrawer({ path: '/results', title: 'results' });
        break;
      case 'create-campaign':
        openDrawer({ path: '/create-campaign', title: 'create-campaign' });
        break;
      case 'campaign':
        openDrawer({ path: '/campaign', title: 'campaign' });
        break;
      case 'imports':
        openDrawer({ path: '/imports', title: 'imports' });
        break;
      case 'exports':
        openDrawer({ path: '/exports', title: 'exports' });
        break;
      case 'bi':
        openDrawer({ path: '/bi', title: 'bi' });
        break;
      case 'templates':
        openDrawer({ path: '/templates', title: 'templates' });
        break;
      case 'people':
        openDrawer({ path: '/people/:id', title: 'people' });
        break;
      case 'offers':
        openDrawer({ path: '/offers', title: 'offers' });
        break;
      case 'results-offers':
        openDrawer({ path: '/results-offers', title: 'results-offers' });
        break;
      case 'campaign-awarded':
        openDrawer({ path: '/campaign-awarded', title: 'campaign-awarded' });
        break;
    }
  };

  return { selectMenuShort };
}